import { useMutation } from "react-query";
import { useApi, apiResolver } from "../useApi";
import {
  SignupRequest,
  SignupResponse,
} from "./signup.model";
import { AxiosInstance } from "axios";

export function useSignupApi(api: AxiosInstance) {
  return {
    signup: async (
      request: SignupRequest
    ): Promise<SignupResponse> => {
      const data = await apiResolver<SignupResponse>(
        api.post('/platform/workspace/signup', request)
      );
      return data;
    },
  };
}

export function useSignup() {
  const { api } = useApi();
  const signupApi = useSignupApi(api);

  return useMutation({
    mutationKey: ["signup"],
    mutationFn: signupApi.signup,
  });
}
